<template>
	<div>
		<nav id="site-navigation" class="main-navigation responsive"
			v-bind:class="{ 'closed': closeNavigation, 'open': !closeNavigation }">
			<template v-if="user">
				<ul>
					<li class="title">
						<span>{{ user.name }} {{ user.surname }}</span>
					</li>
					<li v-if="points" class="pointsValue">
						{{ $t("dashboard.you_have") }} {{ formatNumber(getAvailablePoints(points)) }} {{ $t("dashboard.notes")
						}}
					</li>
					<li v-bind:class="{ ' active': active_el == 1 }">
						<router-link :to="{ name: 'dashboard' }">
							<span>{{ $t("dashboard.dashboard") }}</span>
						</router-link>
					</li>
					<li v-bind:class="{ ' active': active_el == 2 }">
						<router-link :to="{ name: 'surveys' }">
							<span>
								{{ $t("dashboard.surveys") }}
								<span v-if="getProjectCount > 0" class="notification"></span>
							</span>
						</router-link>
					</li>
					<li v-bind:class="{ ' active': active_el == 3 }">
						<router-link :to="{ name: 'awards' }">
							<span>{{ $t("dashboard.points") }}</span>
						</router-link>
					</li>
					<li v-if="isPahse2Enable === true" v-bind:class="{ ' active': active_el == 4 }">
						<router-link :to="{ name: 'newsevents' }">
							<span>{{ $t("dashboard.news_and_events") }}</span>
						</router-link>
					</li>
					<li v-bind:class="{ ' active': active_el == 5 }">
						<router-link :to="{ name: 'myprofile' }">
							<span>{{ $t("dashboard.myprofile") }}</span>
						</router-link>
					</li>
					<li v-bind:class="{ ' active': active_el == 7 }">
						<router-link :to="{ name: 'help-and-support' }">
							<span>{{ $t("dashboard.help_and_support") }}</span>
						</router-link>
					</li>
					<li v-bind:class="{ ' active': active_el == 6 }">
						<router-link :to="{ name: 'about' }">
							<span>{{ $t("dashboard.about_panel") }}</span>
						</router-link>
					</li>
					<li v-if="isPahse2Enable === true" class="icon">
						<a class="messageIcon" href="#">
							<span class="icon warpit_icon_message"></span>
							<span class="notification"></span>
						</a>
					</li>
					<!-- <li>
						<a href="#" @click="showDialog">
							<span>Prenesi aplikacijo</span>
						</a>
					</li> -->
				</ul>

				<AppDialog ref="appDialog"/>
			</template>
		</nav>
	</div>
</template>

<script>
import { formatNumber, getAvailablePoints } from '../helpers.js';
import AppDialog from "@/components/AppDialog";

export default {
	props: ["active_el", "closeNavigation"],
	components: {
		AppDialog,
	},
	data() {
		return {
			isPahse2Enable: false,
			notCompleted: true,
		};
	},
	update() {
		this.user();
		this.points();
		this.projects();
		this.getProjectCount();
	},
	computed: {
		user() {
			return this.$store.getters["user/user"];
		},
		points() {
			return this.$store.getters["user/points"].transactions;
		},
		projects() {
			return this.$store.getters["user/projects"];
		},
		getProjectCount() {
			const projectCount = this.projects.filter(project =>
				project.qStatus != '1' &&
				Array.isArray(project.custom_attributes) &&
				project.custom_attributes.some(attr => attr.value !== "usepoints")
			).length;

			return projectCount;
		},
	},
	mounted() {
		this.loadTransactions();
	},
	methods: {
		loadTransactions() {
			if (this.user) {
				let lang = this.$i18n.locale;
				this.$store.dispatch("user/points", lang);
			}
		},
		formatNumber,
		getAvailablePoints,
		showDialog() {
			this.$refs.appDialog.openDialog();
		}
	},
};
</script>
